export enum Master {
  EntityTypes =100
}

export enum EnumRoleType {
  Contactore =119,
  HR=118
}